import { FC, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useGetCouponOrderQuery } from '@services';
import { OrderView } from '../OrderHistory/OrderView';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  couponId: string;
};

const UsedVoucherOrderViewModal: FC<Props> = ({ isOpen, onClose, couponId }) => {
  const { data, isLoading } = useGetCouponOrderQuery({ couponId });

  return (
    <Dialog
      open={isOpen}
      maxWidth="lg"
      onClose={onClose}
      data-testid="customer-email-change-modal"
      PaperProps={{
        style: { borderRadius: 10 },
      }}
    >
      {' '}
      {isLoading ? (
        <Grid container>
          <Grid item xs={12}>
            <Skeleton animation="wave" variant="rectangular" height={50} width={500} />
          </Grid>
        </Grid>
      ) : (
        <>
          <DialogTitle>
            Order Details
            {onClose && (
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              {data &&
                (data.status !== 'Completed' ? (
                  <Typography>Something went wrong, Try again</Typography>
                ) : (
                  <OrderView order={data} hideRefund={true} />
                ))}
            </Grid>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
};

export default UsedVoucherOrderViewModal;
